import * as React from 'react';
import styled from 'styled-components';
import { CustomerSearchDropdown } from '../../components/customer-search/dropdown';
import { PageHeading } from '../../components/page-heading/page-heading';
import { MangoNavy, White } from '../../styles/colours';
import { Header } from './header';
import { ReactComponent as Graphic } from './home-page-graphic.svg';

export const HOME_PAGE_ROUTE = '/';

const StyledPageHeading = styled(props => <PageHeading {...props} />)`
  color: ${White};
  font-size: 3rem;
`;

const StyledCustomerSearchDropdown = styled.div`
  margin: 4rem 0 18rem 0;
`;

const StyledHomePage = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 100%;

  margin: 0px;
  padding: 0px;

  background: ${MangoNavy};
  color: ${White};
`;

const StyledGraphic = styled(props => <Graphic {...props} />)`
  position: absolute;
  right: 0;
  bottom: 0;
  height: 100%;

  .blink_me:hover {
    animation: blinker 1s;
    animation-iteration-count: 3;
  }

  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
`;

export default function HomePage() {
  return (
    <StyledHomePage data-type="page" data-page={HOME_PAGE_ROUTE}>
      <Header />
      <StyledGraphic />
      <StyledPageHeading>Welcome back</StyledPageHeading>
      <div>Enter your search below</div>
      <StyledCustomerSearchDropdown>
        <CustomerSearchDropdown />
      </StyledCustomerSearchDropdown>
    </StyledHomePage>
  );
}
